<app-icon-with-text
    [icon]="icon"
    [iconColor]="iconColor"
    [iconSizeRem]="iconSizeRem"
    [text]="formattedText"
    [color]="color"
    [sizeRem]="sizeRem"
    [uppercase]="uppercase"
></app-icon-with-text>